<template>
  <div>
    <IconButton
      icon="mdi-cog"
      :tooltip-text="$t('Settings')"
      @click="showDialog = true"
    />
    
    <v-menu 
      v-model="showDialog"      
      :close-on-content-click="false"
      rounded="large"
      offset-y
      absolute
      :position-x="positionX"
      :position-y="positionY"
    >
      <v-card>
        <v-card-title>{{ $t('Settings') }}</v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item>
              <v-list-item-title>{{ $t('DarkTheme') }}</v-list-item-title>
              <v-list-item-action class="mr-4 mt-0 mb-0">
                <v-switch
                  v-model="isDark"
                  color="red"
                  @change="toggleDarkTheme"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-title >{{ $t('Language') }}</v-list-item-title>
              <v-list-item-action class="mr-4 mt-0 mb-0">
                <v-select
                  :value="currentLang"
                  :items="languages"
                  @change="onChangeLang"
                  dense
                  hide-details
                ></v-select>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>{{ $t('KeepFilters') }}</v-list-item-title>
              <v-list-item-action class="mr-4 mt-0 mb-0">
                <v-switch
                  v-model="keepFilters"
                  color="red"
                  @change="toggleKeepFilters"
                />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showDialog = false">
            {{ $t('Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import IconButton from './IconButton.vue';
import { setTranslations } from '@/plugins/i18n';

export default {
  name: 'SettingsButton',
  components: {
    IconButton
  },
  watch: {
    username: {
      immediate: true,
      handler(newUsername) {
        this.keepFilters = this.$localStorageObj.getKeepFiltersValue(newUsername);
      },
    },
  },
  data() {
    return {
      showDialog: false,
      isDark: false,
      keepFilters: false,
      languages: ['en', 'ru'],
      currentLang: 'en',
    };
  },
  async mounted() {
    this.isDark = this.$localStorageObj.getDarkValue();
    this.currentLang = this.$localStorageObj.getLangByUser('');
    try {
      await this.getLangList();
    } catch {
      console.error('error GetLangList');
    }
  },
  methods: {
    toggleDarkTheme() {
      this.$localStorageObj.setDarkValue(this.isDark, '');
      this.$vuetify.theme.dark = this.isDark;
    },
    toggleKeepFilters() {
      this.$localStorageObj.setKeepFiltersValue(this.keepFilters, this.username);
    },
    async onChangeLang(lang) {
      this.$localStorageObj.setUserLang(lang, this.$store.getters.USERNAME);
      // не очень понятно, для чего изначально так устанавливали, 
      // но, видимо, как-то связано с дефолтным языком, 
      // который показывает при разлогине
      this.$localStorageObj.setUserLang(lang, '');
      this.currentLang = lang;

      await setTranslations(lang);
    },
    async getLangList() {
      this.$axios.langs
        .getList()
        .then((response) => response)
        .then((json) => {
          this.languages = json.data.langs.split(',');
        });
    },
  },
  computed: {
    username() {
      return this.$store.getters.USERNAME;
    },
    positionX() {
      return window.innerWidth - 20; // 20px отступ справа
    },
    positionY() {
      return 64; // высота appbar
    }
  }
};
</script>